import mapFunction from './mapResources';

export default mapFunction('operation_list', {
    isFetching: false,
    items: [] 
});